import { Weekday } from './types';

export const AVAILABILITY_TIMES_START_HOUR = 4;
export const AVAILABILITY_TIMES_UNTIL_HOUR = 22;

export const AVAILABILITY_TIMES: Date[] = (() => {
  const times: Date[] = [];
  for (let hour = AVAILABILITY_TIMES_START_HOUR; hour <= AVAILABILITY_TIMES_UNTIL_HOUR; hour++) {
    times.push(new Date(Date.UTC(1970, 0, 1, hour)));
  }
  return times;
})();

export const WEEKDAYS: Weekday[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

export const DEFAULT_UNAVAILABILITY = {
  forever: true,
  start_date: null,
  until_date: null,
  mon: false,
  tue: false,
  wed: false,
  thu: false,
  fri: false,
  sat: false,
  sun: false,
} as const;
